import { Component } from "react";
import { useNavigate } from "react-router";

import DashboardCard from "./DashboardCard";

import AuthenticationComponent from "./AuthenticationComponent";

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const history = useNavigate();
    return <Component history={history} {...props} />;
  };
  return Wrapper;
};

class DashboardOverview extends Component {
  render() {
    return (
      <AuthenticationComponent>
        {() => {
          return (
            <div className="DashboardOverview">
              <DashboardCard name="Organization-Name" click={() => this.props.history("/organization")}>
                <h3>Gets organization name</h3>
              </DashboardCard>

              <DashboardCard name="UserInfo" click={() => this.props.history("/userinfo")}>
                <h3>Gets user info</h3>
                <h4>Using userId (subject)</h4>
              </DashboardCard>

              <DashboardCard name="Projects" click={() => this.props.history("/projects")}>
                <h3>Projects</h3>
                <h4>Lists all project in organization</h4>
              </DashboardCard>

              <DashboardCard name="Deployments" click={() => this.props.history("/deployments")}>
                <h3>Deployments</h3>
              </DashboardCard>

              <DashboardCard name="Publish project eView" click={() => this.props.history("/publish")}>
                <h3>eViewService logs only (Old)</h3>
                <h4>Includes all tests, App Insights</h4>
              </DashboardCard>
            </div>
          );
        }}
      </AuthenticationComponent>
    );
  }
}

export default withRouter(DashboardOverview);
